import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import quotationListView from "Views/quotationListView.js";
import templateContent from "Templates/components/quotation-item-modal.html";

class QuotationItemModal extends Component {
	constructor () {
		super("quotationItemModal");
		this.addTemplate("", templateContent);
	}


		
	addQuotationItemsBtn_clickHandler () {
		const resinList = Shark.get("resinList");
		const resinItems = [];

		$("#quotationItemModal .resinsChk:checked").each((index, item) => {
			const resin = Utils.safp(resinList, "code", $(item).data("code"));
			if (resin) {
				resinItems.push(resin);
			}
		});
		console.log(resinItems);

		Shark.get("currQuotation").set("resinItems", resinItems);
		$("#quotationItemModal").modal("hide");
		Shark.render();
	}

	beforeRender (event) {
		// let userRoles = Shark.get("currUser").roles;
		// let userIsSellRepresentativeOnly = false;
		// userIsSellRepresentativeOnly = userRoles.length === 1 && (userRoles.indexOf("sellRepresentative") !== -1);

		// const siteInfoSheetList = Shark.get("siteInfoSheetList");

		Shark.activePage.set({
			// __hideMenu: Shark.activePage.id === "loginView" || Shark.activePage.id === "registrationView",
			// __userPageActive: Shark.activePage.id === "userListView",
			// __clientPageActive: Shark.activePage.id === "clientListView",
			// __homePageActive: Shark.activePage.id === "homeView",
			// __quotationPageActive: Shark.activePage.id === "quotationListView",
			// __sheetPageActive: Shark.activePage.id === "siteInfoSheetListView",
			// __siteInfoSheetCount: siteInfoSheetList ? siteInfoSheetList.length : 0,
			// __documentsPageActive: Shark.activePage.id === "documentListView",
			// currUser: Shark.get("currUser"),
			// userIsSellRepresentativeOnly: userIsSellRepresentativeOnly
		});
	}

	quotationBtn_clickHandler (event) {
		Shark.openPage(quotationListView);
	}
}

const quotationItemModal = new QuotationItemModal();


Shark.registerComponent(quotationItemModal);

export { quotationItemModal };
